import { useId } from 'react';
import { cx } from "@/lib/utils";

export type GlowingCircleSize = 'sm' | 'md' | 'lg' | number;

const sizeVarMap = {
  sm: 'var(--size-circle-sm)',
  md: 'var(--size-circle-md)',
  lg: 'var(--size-circle-lg)',
} as const;

interface GlowingCircleProps {
  /** Size preset ('sm' | 'md' | 'lg') or pixel number */
  size?: GlowingCircleSize;
  /** Animation duration in seconds for the pulse effect */
  duration?: number;
  /** Glow color (hex code) */
  color?: string;
  children?: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export default function GlowingCircle({
  size = 'md',
  duration = 3,
  color = '#49FCFE',
  className = '',
  children,
  onClick,
}: GlowingCircleProps) {

  const id = useId();
  const gradientId = `glow-gradient-${id}`;
  const cssSize = typeof size === 'number' ? `${size}px` : sizeVarMap[size];

  return (
    <div
      className={cx('relative flex items-center justify-center', className, onClick && 'cursor-pointer')}
      style={{
        width: cssSize,
        height: cssSize,
      }}
      onClick={onClick}
    >
      <svg
        className="absolute inset-0 animate-pulse-glow"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 200 200"
        fill="none"
        preserveAspectRatio="xMidYMid meet"
        style={{ animationDuration: `${duration}s`, transformOrigin: 'center' }}
      >
        <circle cx="100" cy="100" r="100" fill={`url(#${gradientId})`} />
        <defs>
          <radialGradient id={gradientId} cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(100 100) rotate(90) scale(100)">
            <stop stopColor={color} />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </radialGradient>
        </defs>
      </svg>

      <div className="relative z-20">{children}</div>
    </div>
  );
}
